export const ADDRESS_INVALID_ERROR = "Address is invalid or name does not exist"
export const NOT_AVAILABLE_ERROR =
    "This application is not available during Pack Drops and Faucets. Please try again later."
